/*
 * states: possible states as provided by the backend
 * filterStates: possible states as we provide in the UI for the filter dropdown
 *
 */

export const BookingStates = [
  'confirmed',
  'pending',
  'expired',
  'taken',
  'rejected',
  'cancelled',
];
export const FilterBookingStates = [
  'active',
  'expired',
  'cancelled',
  'taken',
  'rejected',
];
